export default "__VITE_ASSET__D4vpzZc9__"